import type { HomePageActions, HomePageState } from "./types";

const INITIAL_STATE: HomePageState = {
  loading: false,
  error: false,
  data: {
    waysWeCanHelpData: [],
    financialData: [],
    carouselData: [],
    quickLinks: [],
    productBanner: [],
    latest_news: [],
    advisories: [],
  },
};

export default (
  state: HomePageState = INITIAL_STATE,
  action: HomePageActions
): HomePageState => {
  switch (action.type) {
    case "REQUEST_HOME_PAGE_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case "REQUEST_HOME_PAGE_DATA_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    }
    case "REQUEST_HOME_PAGE_DATA_FAILED": {
      return {
        ...state,
        loading: false,
        error: false,
      };
    }
    default: {
      return state;
    }
  }
};
